import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject } from '@mri/types';

@Pipe({
  name: 'elementsForView',
  standalone: true
})
export class ElementsForViewPipe implements PipeTransform {

  transform(sources: Array<AnyObject>, fixedSources: Array<AnyObject>, fixedIds: Set<string>): Array<AnyObject> {
    if (!sources) return [];

    fixedSources = fixedSources?.length > 0 ? [...(fixedSources || []), {type: 'separator', label: 'Marcados'}] : [];

    return [...(fixedSources), ...(sources || []).filter(s => !fixedIds.has(s._id))];
  }

}
